import { SelectOption } from "rizzui";

export function getOptionByValue(value: string, options: any[]) {
    return options.find((option) => option.value === value);
}

// enum into options for select
/// @param enumObj - The enum object.
/// @param ignore - The keys to ignore.
/// @returns The options for the select.
export function enumToOptions(enumObj: any, ignore?: string[]): SelectOption[] {
    return Object.keys(enumObj)
        .filter((key) => !ignore?.includes(key))
        .map((key) => ({
            label: key,
            value: enumObj[key],
        }));
}
